import IMask from "imask";

export default class Forms {
    constructor() {
    }

    static wrongMessages() {
        let mensagens = {
                messages: {
                    missingValue: {
                        checkbox: "Este campo é obrigatório.",
                        radio: "Por favor selecione um valor.",
                        select: "Por favor selecione um valor.",
                        "select-multiple":
                            "Por favor selecione pelo menos um valor.",
                        default: "Por favor preencha este campo",
                    },
                    patternMismatch: {
                        email: "Insira um endereço de e-mail corporativo válido.",
                        url: "Informe uma url.",
                        number: "Informe o telefone",
                        date: "Por favor utilizar o formato DD/MM/YYYY",
                        default: "Por favor, preencha o campo com conteúdo válido.",
                    },
                    outOfRange: {
                        over: "Selecione um valor que não seja superior a {max}.",
                        under: "Selecione um valor que não seja inferior a {min}.",
                    },
                    wrongLength: {
                        over: "Reduza este texto para não mais que {maxLength} caracteres. Você está usando atualmente {length} caracteres.",
                        under: "Por favor, estenda este texto para {minLength} caracteres ou mais. Você está usando atualmente {length} caracteres.",
                    },
                },
            };
        return mensagens;
    }

    static maskFormFields() {

        const phoneField = document.querySelectorAll(".telMask:not([data-mask-initialized])")
        const dateField = document.querySelectorAll(".dateMask:not([data-mask-initialized])")

        if(phoneField.length > 0) {
            phoneField.forEach(field => {
                const digits = field.value.replace(/\D/g, "");

                if (/^55\d{10,11}$/.test(digits)) {
                    field.value = digits.substring(2);
                }

                let phoneMask = IMask(field, {
                    mask: "(00) 00000-0000",
                });

                field.dataset.maskInitialized = "true";
            })
        }

        if(dateField.length > 0) {
            dateField.forEach(field => {
                let dateMask = IMask(field, {
                    mask: Date,
        
                    pattern: "d/`m/`Y",
                    blocks: {
                        d: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 31,
                        },
                        m: {
                            mask: IMask.MaskedRange,
                            from: 1,
                            to: 12,
                        },
                        Y: {
                            mask: IMask.MaskedRange,
                            from: 19000,
                            to: 20290,
                        },
                    },
                });

                field.dataset.maskInitialized = "true";
            })
        }
    }
}
